// extracted by mini-css-extract-plugin
export default {"pageContent":"Redirect_pageContent__jznO0","pageTitle":"Redirect_pageTitle__VvF6h","ellipsis":"Redirect_ellipsis__HIUmi"};